// ReCircle Foundation - Website Content (EXACT from PDF)

export const navigationLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Focus Areas', path: '/focus-areas' },
  { name: 'Knowledge Centre', path: '/blog' },
  { name: 'Impact', path: '/impact' },
  { name: 'Get Involved', path: '/get-involved' }
];

export const heroContent = {
  title: "Building the Social Infrastructure\nBehind India's Circular Future"
};

export const aboutFoundation = {
  intro: "For decades, India's circular economy has survived on the backs of communities who were never meant to benefit from it. \nThat never felt right to us.",
  mission: "ReCircle Foundation was created to change this. Our mission is to build an ethical, inclusive, and self-sustaining circular economy.",
  approach: "We channel CSR and philanthropic capital to protect and formalise Safai Saathis, build infrastructure that keeps waste in \ncirculation, and drive behaviour change in communities so the system doesn't rely on just a few people to carry it.",
  parentOrg: "Our parent organisation, ReCircle, has spent years creating recovery systems that keep waste in the loop. \nThe Foundation carries that work forward by ensuring the people powering those systems are not left behind.",
  goal: "Our goal is to create a long-term impact that sustains itself for generations."
};

export const sdgCommitments = [
  {
    number: "8",
    title: "Decent Work & Economic Growth",
    description: "Through our Safai Saathi programs, we formalise livelihoods, strengthen incomes, and enable safer, more dignified work opportunities.",
    icon: "/assets/HomePage/SDGUnits/1.png"
  },
  {
    number: "9",
    title: "Industry, Innovation & Infrastructure",
    description: "We design transparent waste systems and continuously innovate to keep materials in circulation while integrating informal workers into value chains.",
    icon: "/assets/HomePage/SDGUnits/2.png"
  },
  {
    number: "11",
    title: "Sustainable Cities & Communities",
    description: "Through on-ground citizen awareness campaigns, we drive behaviour change that makes circular living a natural part of everyday urban life.",
    icon: "/assets/HomePage/SDGUnits/3.png"
  },
  {
    number: "12",
    title: "Responsible Consumption & Production",
    description: "We advance the circular economy by building structured systems for waste reduction, recovery, and scalable recycling infrastructure.",
    icon: "/assets/HomePage/SDGUnits/4.png"
  },
  {
    number: "13",
    title: "Climate Action",
    description: "By diverting waste from landfills through circular programs, we reduce emissions and protect the environment over the long term.",
    icon: "/assets/HomePage/SDGUnits/5.png"
  },
  {
    number: "14",
    title: "Life Below Water",
    description: "We prevent ocean pollution by strengthening land-based collection & diversion systems and by fostering source-level awareness.",
    icon: "/assets/HomePage/SDGUnits/6.png"
  },
  {
    number: "17",
    title: "Partnerships for the Goals",
    description: "We collaborate with governments, businesses, and communities to co-create resilient, lasting circular solutions.",
    icon: "/assets/HomePage/SDGUnits/7.png"
  }
];

export const focusAreasPreview = [
  {
    title: "WASTE DIVERSION",
    description: "Keeping valuable materials in circulation, out of landfills",
    icon: "/assets/HomePage/OurActionAreaIcons/Waste-Diversion-Icon.png"
  },
  {
    title: "FORMALISATION OF SAFAI SAATHIS",
    description: "Securing wages, safety, recognition, and better livelihoods",
    icon: "/assets/HomePage/OurActionAreaIcons/Safaai-Saathis-icon.png"
  },
  {
    title: "WASTE INTO RESOURCES",
    description: "Giving waste a second life as reliable raw materials & products.",
    icon: "/assets/HomePage/OurActionAreaIcons/Waste-into-resources-icon.png"
  },
  {
    title: "BEHAVIOURAL CHANGE",
    description: "Empowering individuals to participate in the circular economy.",
    icon: "/assets/HomePage/OurActionAreaIcons/Behavioural-change-icon.png"
  },
  {
    title: "LIVELIHOOD OPPORTUNITIES",
    description: "Building skills, confidence, and long-term opportunity through IEC",
    icon: "/assets/HomePage/OurActionAreaIcons/Livelihood-Opportunities.png"
  },
  {
    title: "HEALTH & SAFETY ACCESS",
    description: "Providing check-ups, safety training, and healthcare access",
    icon: "/assets/HomePage/OurActionAreaIcons/Health-and-safty-icon.png"
  }
];

export const impactStats = [
  {
    number: "291,217 MT",
    description: "Waste diverted from polluting our landfills and oceans"
  },
  {
    number: "3,608+",
    description: "Livelihoods impacted"
  },
  {
    number: "310+",
    description: "waste recovery sites across villages, towns & cities"
  },
  {
    number: "9+",
    description: "Years of driving a Circular Economy"
  },
  {
    number: "4+",
    description: "Years of consistently measuring impact"
  }
];

export const contactCTA = {
  title: "Take the First Step Towards Real Impact",
  description: "Partner with ReCircle Foundation to build systems that protect livelihoods and sustain themselves."
};

// ABOUT PAGE CONTENT
export const aboutPageHero = {
  title: "ReCircle Foundation\nwas Built for the People\nBehind the System"
};

export const aboutPageContent = {
  founded: "ReCircle Foundation (the impact arm of ReCircle) was founded in 2025 as a Section 8 non-profit to strengthen the human side of circularity by enabling inclusive livelihoods and fair, transparent systems.",
  story: "We can build a world where no waste goes to waste and call it a day. But a decade in waste recovery taught us that infrastructure is only half the story. The other half are India's waste workers, who show up every day without a wage slip, insurance, and so much as a government ID to prove they exist.",
  commitment: "As your CSR/ESG partner, we apply a three-pronged approach to direct capital to create lasting change, drive behaviour change so more waste stays in circulation, and strengthen the systems that allow this work to continue long after we've left the room.",
  conclusion: "While the Foundation's journey has just begun, the work behind it is built on decades of experience of our parent organisation, ReCircle, which has been creating environmental and social impact across India's waste ecosystem.",
  exploreImpact: "Explore that impact below."
};

export const visionItems = [
  {
    title: "Formalises & Protects Safai Saathis",
    description: "ensuring circularity creates stable, dignified livelihoods.",
    icon: "/assets/AboutPage/OurVisionIcons/Our-Vision-Formalises-And-protects-people-icon.png"
  },
  {
    title: "Drives Behavioral Change",
    description: "at the grassroots level so more material stays in circulation",
    icon: "/assets/AboutPage/OurVisionIcons/Our-Vision-Drive-behavioural-change-icon.png"
  },
  {
    title: "Directs Capital",
    description: "to strengthen recovery systems and allow them to sustain themselves.",
    icon: "/assets/AboutPage/OurVisionIcons/Our-Vision-Direct-capital-icon.png"
  }
];

export const corePillars = [
  {
    title: "INCLUSIVITY",
    description: "for those at the base of the waste value chain: ensuring circularity creates opportunity for the people who sustain it.",
    icon: "/assets/AboutPage/CorePillarsIcons/Core-Pillars-Inclusivity.png"
  },
  {
    title: "COLLABORATION",
    description: "across sectors to pool resources, share responsibility, and build systems that no single actor can build alone.",
    icon: "/assets/AboutPage/CorePillarsIcons/Core-Pillars-Collaboration-icon.png"
  },
  {
    title: "TRANSPARENCY",
    description: "at every step, which ensures every initiative is measured and accountable.",
    icon: "/assets/AboutPage/CorePillarsIcons/Core-Pillars-Transparency-icon.png"
  },
  {
    title: "INNOVATION",
    description: "in how waste is understood and managed, using design, technology, and storytelling to turn circular living into everyday practice.",
    icon: "/assets/AboutPage/CorePillarsIcons/Core-Pillars-Innovation-icon.png"
  },
  {
    title: "LOCAL-FIRST",
    description: "in our execution, building and proving models in Mumbai before scaling them through our national partner network.",
    icon: "/assets/AboutPage/CorePillarsIcons/Core-Pillars-Innovation-icon(2).png"
  },
  {
    title: "INSIGHT-DRIVEN",
    description: "in every intervention, designed around what communities need to sustain themselves, not what looks good on paper.",
    icon: "/assets/AboutPage/CorePillarsIcons/Core-Pillars-Insight-Driven-icon.png"
  }
];

export const teamMembers = [
  {
    name: "Rahul Nainani",
    designation: "Director",
    image: "/assets/AboutPage/Team/Rahul.png",
    linkedinUrl: "https://www.linkedin.com/in/rahulnainani/"
  },
  {
    name: "Gurashish Sahni",
    designation: "Director",
    image: "/assets/AboutPage/Team/Guru.png",
    linkedinUrl: "https://www.linkedin.com/in/gurashish123/"
  },
  {
    name: "Rohit Lalwani",
    designation: "Adviser",
    image: "/assets/AboutPage/Team/Rohit.png",
    linkedinUrl: "https://www.linkedin.com/in/lalwanirohit/"
  },
  {
    name: "Shraddha Shelatkar",
    designation: "Grant Management Executive",
    image: "/assets/AboutPage/Team/Shraddha.png",
    linkedinUrl: "https://www.linkedin.com/in/shraddha-shelatkar-b735191ab/"
  }
];

// FOCUS AREAS PAGE CONTENT
export const focusAreasIntro = {
  title: "If circularity can give materials a second life, why should people be left behind?",
  description: "This is the question we have always asked, and the one we continue to ask as we build systems for recovery with partners who believe their CSR can do more than just meet compliance obligations.",
  conclusion: "That is where our work begins."
};

export const focusAreasDetailed = [
  {
    id: "waste-diversion",
    title: "WASTE DIVERSION",
    content: "Nothing valuable belongs in a landfill. Yet India generates 20 million tonnes of recoverable materials every year, which could have been recovered but were lost to landfills instead.\n\nThrough organised collection networks, traceable recovery systems, and responsible processing, we redirect materials back into circulation. Every kilo diverted reduces landfill pressure, lowers emissions, and protects ecosystems already under strain, creating measurable environmental outcomes for organisations advancing their CSR commitments.",
    cta: "Explore waste recovery"
  },
  {
    id: "formalisation",
    title: "FORMALISATION OF SAFAI SAATHIS",
    content: "Every system works only because of the people powering it, and a circular economy is no exception.\n\nYet waste workers remain excluded from the very system they sustain, without documentation, protection or any stability.\n\nWe help formalise their roles, secure fair wages, provide safety gear, ensure they get access to health care, and restore the dignity they were always owed.",
    cta: "Support Safai Saathis!"
  },
  {
    id: "waste-into-resources",
    title: "TURNING WASTE INTO RESOURCES",
    content: "Waste did its job once. It can do it again. What you call trash – paper, plastic, metal, paper & textiles – has potential for another life.\n\nWe recover and process these discarded materials into raw materials or recycled products, such as coasters, benches, tote bags, and other fun and functional products.\n\nThis helps reduce the need to extract resources that the planet cannot replenish.",
    cta: "Explore recycled products."
  },
  {
    id: "behavioral-change",
    title: "DRIVING BEHAVIORAL CHANGE",
    content: "Every circular system begins with a human decision. And sometimes those decisions look like segregating waste at the source, returning materials, or simply choosing better.\n\nConscious behaviour is what drives these decisions. That's why we partner with schools, organisations, and residential societies to make this easier to understand and easier to practise, helping translate CSR intent into everyday action.",
    cta: "Start a Program."
  },
  {
    id: "livelihood",
    title: "SECURING LIVELIHOOD OPPORTUNITIES",
    content: "Waste recovery already creates value. But that value does not always reach the people closest to it.\n\nThrough training, education, and skill-building, we help individuals grow into stronger, more secure livelihoods.\nWith greater stability comes greater confidence and the ability to make better choices for oneself.",
    cta: "Empower livelihoods."
  },
  {
    id: "health-safety",
    title: "HEALTH & SAFETY ACCESS",
    content: "If we are serious about protecting the planet, we must be just as serious about protecting the people who do that work every day. Waste recovery deserves the same care, structure, and safeguards as any other profession.\n\nThat is why we ensure our partner Safai Saathis have access to regular health check-ups, safety training, protective equipment, and support systems they can rely on.\n\nAfter all, progress means very little if the people driving it are left unprotected.",
    cta: "Protect frontline workers."
  }
];

// GET INVOLVED PAGE CONTENT
export const getInvolvedHero = {
  title: "Partner for Impact!",
  description: "When you work with us, you help create systems that keep waste in circulation, empower informal workers with dignity and opportunity, and drive behavioural change at the grassroots level.",
  tagline: "If you are here, you already know business as usual is not enough."
};

export const images = {
  impactHero: "/assets/ImpactPage/Impact-Page-Banner.png",
  hero: "/assets/HomePage/HomeBanner/Home-Page-Banner.png",
  aboutMission: "/assets/AboutPage/HeroBanner/About-Page-Banner.png",
  getInvolvedHero: "/assets/GetInvolvedPage/Get-Involved-Banner-Safai-Saathi.png",
  focusAreasHero: "/assets/FocusAreasPage/FocusAreasMainBanner/Focus-Areas-Main-Banner.png",
  wasteDiversion: "/assets/FocusAreasPage/Images/WASTE-DIVERSION.png",
  formalisation: "/assets/FocusAreasPage/Images/FORMALISATION-OF-SAFAI-SAATHIS.png",
  wasteResources: "/assets/FocusAreasPage/Images/TURNING-WASTE-INTO-RESOURCES.png",
  behavioralChange: "/assets/FocusAreasPage/Images/DRIVING-BEHAVIORAL-CHANGE.png",
  livelihood: "/assets/FocusAreasPage/Images/SECURING-LIVELIHOOD-OPPORTUNITIES.png",
  healthSafety: "/assets/FocusAreasPage/Images/HEALTH-AND-SAFETY-ACCESS.png",
  logo: "/assets/LogoUnits/ReCircle-Foundation-Logo.png",
  logoWhite: "/assets/LogoUnits/ReCircle-Foundation-Logo-WHITE.png",
  footerIcons: {
    Facebook: "/assets/HomePage/FooterIcons/SocialMediaIcons/Facebook.png",
    Instagram: "/assets/HomePage/FooterIcons/SocialMediaIcons/Instagram.png",
    LinkedIn: "/assets/HomePage/FooterIcons/SocialMediaIcons/LinkedIn.png",
    Call: "/assets/HomePage/FooterIcons/Call.png",
    Email: "/assets/HomePage/FooterIcons/Email.png",
    Location: "/assets/HomePage/FooterIcons/Location.png"
  },
  getInvolvedContactIcons: {
  callUs: "assets/GetInvolvedPage/ContactIcons/Call-Us.png",
  emailUs: "assets/GetInvolvedPage/ContactIcons/Email-Us.png",
  visitUs: "assets/GetInvolvedPage/ContactIcons/Visit-Us.png"
}
};


export const impactPageContent = {
  heroTitle: "Driven by a decade of expertise",
  heroIntro: "Before the Foundation began its journey, our parent organisation, ReCircle, had already laid the groundwork. The ReCircle Foundation carries that work forward, focusing on the people and communities who make circularity possible.",
  heroSubtext: "While our journey has only just begun, the impact behind us is already a decade strong.",
  exploreText: "Explore ReCircle's impact below.",
  requiredInfoText:"*All impact numbers on this page come from the work done by our parent company, ReCircle.",
  statsTitle: "The impact so far",
  statsFootnote: " *The impact above reflects the work of our parent company, ReCircle, which has spent the last decade building the foundations of India's circular economy.",
  reportSectionTitle: "A Year of Ethical Circularity",
  reportDescription1: "These Impact Reports capture the progress of our parent organisation, ReCircle, whose decade-long journey continues to shape how waste, resources, and livelihoods intersect across the country.",
  reportDescription2: "The Foundation builds on this legacy by bringing the systems, networks, and on-ground learnings directly to the communities and people who power India’s recycling economy.",
  reportCTA: "Explore ReCircle’s previous Impact Reports here",
  reportButtonText: "STEP INSIDE OUR CIRCLE",
  reportLink: "https://heyzine.com/flip-book/c80175cc63.html"
};
